import { render, staticRenderFns } from "./PaidTaskBanner.vue?vue&type=template&id=03502a6e&"
import script from "./PaidTaskBanner.vue?vue&type=script&lang=ts&"
export * from "./PaidTaskBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports